import { useMMKVString } from 'react-native-mmkv';

import { storage, storageKeys } from '@/constants/storage';

/**
 * Whether a signed-in session is stored. A guest who checked out keeps the
 * customer id the checkout returned but has no session, and customer-only
 * endpoints answer them 401, so those queries gate on this, not the id.
 */
export const useHasSession = (): boolean => {
  const [authToken] = useMMKVString(storageKeys.authToken, storage);
  return !!authToken;
};
